import {http} from '@/helpers/http-helper';

class Community {
    constructor(
        uuid,
        code,
        name
    ) {
        this.uuid = uuid;
        this.code = code;
        this.name = name;
    }
}

class Province {
    constructor(
        uuid,
        code,
        name,
        community
    ) {
        this.uuid = uuid;
        this.code = code;
        this.name = name;
        this.community = community;
    }
}

class Town {
    constructor(
        uuid,
        code,
        name,
        province
    ) {
        this.uuid = uuid;
        this.code = code;
        this.name = name;
        this.province = province;
    }
}

class PostalCode {
    constructor(
        uuid,
        code,
        town
    ) {
        this.uuid = uuid;
        this.code = code;
        this.name = name;
        this.town = town;
    }
}

export const getCommunities = () => {
    return new Promise((resolve, reject) => {
        const url = 'communities';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let communities = [];

                    response.data.forEach((community) => {
                        communities.push(
                            new Community(
                                community.uuid,
                                community.code,
                                community.name
                            )
                        );
                    });

                    resolve(communities);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getProvinces = (communityId) => {
    return new Promise((resolve, reject) => {
        const url = !communityId ? 'provinces' : `communities/${communityId}/provinces`;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let provinces = [];
                    response.data.forEach((province) => {
                        provinces.push(
                            new Province(
                                province.uuid,
                                province.code,
                                province.name,
                                new Community(
                                    province.community.uuid,
                                    province.community.code,
                                    province.community.name
                                )
                            )
                        );
                    });

                    resolve(provinces);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getTowns = (provinceId) => {
    return new Promise((resolve, reject) => {
        const url = !provinceId ? 'towns' : `provinces/${provinceId}/towns`;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let towns = [];
                    response.data.forEach((town) => {
                        towns.push(
                            new Town(
                                town.uuid,
                                town.code,
                                town.name,
                                new Province(
                                    town.province.uuid,
                                    town.province.code,
                                    town.province.name,
                                    new Community(
                                        town.province.community.uuid,
                                        town.province.community.code,
                                        town.province.community.name
                                    )
                                )
                            )
                        );
                    });

                    resolve(towns);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getPostalCodes = (townId) => {
    return new Promise((resolve, reject) => {
        const url = !townId ? 'postalcodes' : `towns/${townId}/postalcodes`;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let postalCodes = [];
                    response.data.forEach((postalCode) => {
                        postalCodes.push(
                            new PostalCode(
                                postalCode.uuid,
                                postalCode.code,
                                new Town(
                                    postalCode.town.uuid,
                                    postalCode.town.code,
                                    postalCode.town.name,
                                    new Province(
                                        postalCode.town.province.uuid,
                                        postalCode.town.province.code,
                                        postalCode.town.province.name,
                                        new Community(
                                            postalCode.town.province.community.uuid,
                                            postalCode.town.province.community.code,
                                            postalCode.town.province.community.name
                                        )
                                    )
                                )
                            )
                        );
                    });

                    resolve(postalCodes);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};


export const createPostalCode = (
  townId,
  postalCode
) => {
  return new Promise((resolve, reject) => {
    const url = 'postalcodes';
    http.post(url, {
      townId,
      postalCode
    })
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
